export class HomeClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/homes`;
  }

  async getHomeMembers(id) {
    const url = `${this.baseURL}/${id}/members`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getHomeMembersHistory(id) {
    const url = `${this.baseURL}/${id}/members/histories`;

    const response = await this.httpClient.request("get", url);

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/member-management/homes.js